/** Colunas do order by da pesquisa dos grupos econômicos */
export enum ClienteGrupoEconomicoSearchOrderBy {
    Codigo = 1,
    Nome = 2,
    Situacao = 3
};
